import { ThematicCategorySlug } from "../models/category.model";

// Pillar slugs (from database)
export type PillarSlug = 'individual' | 'environment' | 'event';

// French translations for pillars
export const PILLAR_TRANSLATIONS: Record<PillarSlug, string> = {
  'individual': "L'Individu",
  'environment': "L'Environnement",
  'event': "Les Événements",
};

// Pillar colors
const strongPillarColors: Record<PillarSlug, string> = {
  'individual': '#2464A0',    // Blue - for personal/individual themes
  'environment': '#239692',   // Teal - for environment/context themes
  'event': '#B65A44',         // Orange/Brown - for life events
};

const lightPillarColors: Record<PillarSlug, string> = {
  'individual': '#B4CBE0',
  'environment': '#B4DDDB',
  'event': '#E8C7C0',
};

const mediumPillarColors: Record<PillarSlug, string> = {
  'individual': '#5491CB',
  'environment': '#53C1BD',
  'event': '#E28873',
};

/** @deprecated Use pillar colors instead */
const strongCategoryColors: Record<ThematicCategorySlug, string> = {
  [ThematicCategorySlug.BETTER_LIFE]: '#E8D414',
  [ThematicCategorySlug.PERSONAL_LIFE]: '#2464A0',
  [ThematicCategorySlug.PROFESSIONAL_LIFE]: '#B65A44',
  [ThematicCategorySlug.SELF_REFLECTION]: '#239692'
};

/** @deprecated Use pillar colors instead */
const lightCategoryColors: Record<ThematicCategorySlug, string> = {
  [ThematicCategorySlug.BETTER_LIFE]: '#F5F0B7',
  [ThematicCategorySlug.PERSONAL_LIFE]: '#B4CBE0',
  [ThematicCategorySlug.PROFESSIONAL_LIFE]: '#E8C7C0',
  [ThematicCategorySlug.SELF_REFLECTION]: '#B4DDDB'
};

/** @deprecated Use pillar colors instead */
const mediumCategoryColors: Record<ThematicCategorySlug, string> = {
  [ThematicCategorySlug.BETTER_LIFE]: '#F2E14D',
  [ThematicCategorySlug.PERSONAL_LIFE]: '#5491CB',
  [ThematicCategorySlug.PROFESSIONAL_LIFE]: '#E28873',
  [ThematicCategorySlug.SELF_REFLECTION]: '#53C1BD'
};


export {
  lightCategoryColors,
  mediumCategoryColors,
  strongCategoryColors,
  lightPillarColors,
  mediumPillarColors,
  strongPillarColors
};
